import { render, staticRenderFns } from "./flowFormConfig.vue?vue&type=template&id=d9442030&scoped=true&"
import script from "./flowFormConfig.vue?vue&type=script&lang=js&"
export * from "./flowFormConfig.vue?vue&type=script&lang=js&"
import style0 from "./flowFormConfig.vue?vue&type=style&index=0&id=d9442030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9442030",
  null
  
)

export default component.exports